if (!customElements.get("section-controller-swiper")) {
  class SectionControllerSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.mainSwiperEl = this.querySelector("[data-main-swiper]");
      this.titleSwiperEl = this.querySelector("[data-title-swiper]");
      this.textSwiperEl = this.querySelector("[data-text-swiper]");
      this.mainSwiperOptions = {
        slidesPerView: 2.5,
        spaceBetween: 150,
        centeredSlides: true,
        speed: 500,
        loop: true,
        navigation: {
          nextEl: this.querySelector(".swiper-navigation-next"),
          prevEl: this.querySelector(".swiper-navigation-prev"),
        },
      };
    }
    connectedCallback() {
      this.titleSwiper = new Swiper(this.titleSwiperEl, {
        effect: "fade",
        speed: 500,
        allowTouchMove: false,
      });
      this.textSwiper = new Swiper(this.textSwiperEl, {
        effect: "fade",
        speed: 500,
        allowTouchMove: false,
      });
      this.mainSwiper = new Swiper(this.mainSwiperEl, {
        ...this.mainSwiperOptions,
        on: {
          transitionStart: (swiper) => {
            this.titleSwiper.slideTo(swiper.realIndex);
            this.textSwiper.slideTo(swiper.realIndex);
          },
        },
      });
    }
  }
  customElements.define("section-controller-swiper", SectionControllerSwiper);
}
